import { ChainId } from '@pancakeswap/sdk'
import memoize from 'lodash/memoize'
import invert from 'lodash/invert'
import { Chain } from 'wagmi/chains'
import { IS_PROD, mantle, mantleTestnet } from '@pancakeswap/address-config'

export const CHAIN_QUERY_NAME = {
  [ChainId.MANTLE]: 'mantle',
  [ChainId.MANTLE_TESTNET]: 'mantleTestnet',
  // [ChainId.ETHEREUM]: 'eth',
  // [ChainId.GOERLI]: 'goerli',
  // [ChainId.MANTLE]: 'bsc',
  // [ChainId.MANTLE_TESTNET]: 'bscTestnet',
} as const satisfies Record<ChainId, string>

const CHAIN_QUERY_NAME_TO_ID = invert(CHAIN_QUERY_NAME)

export const getChainId = memoize((chainName: string) => {
  if (!chainName) return undefined
  return CHAIN_QUERY_NAME_TO_ID[chainName] ? +CHAIN_QUERY_NAME_TO_ID[chainName] : undefined
})

// const bsc = {
//   ...bsc_,
//   rpcUrls: {
//     ...bsc_.rpcUrls,
//     public: {
//       ...bsc_.rpcUrls.public,
//       http: ['https://bsc-dataseed.binance.org/'],
//     },
//     default: {
//       ...bsc_.rpcUrls.default,
//       http: ['https://bsc-dataseed.binance.org/'],
//     },
//   },
// } satisfies Chain

// const mantle = {
//   id: 5000,
//   name: 'Mantle Chain',
//   network: 'mnt',
//   nativeCurrency: { decimals: 18, name: 'MNT', symbol: 'MNT' },
//   rpcUrls: {
//     default: { http: ['https://rpc.mantle.xyz'] },
//     public: { http: ['https://rpc.mantle.xyz'] },
//   },
//   blockExplorers: {
//     // etherscan: { name: 'MantleScan', url: 'https://explorer.mantle.xyz/' },
//     default: { name: 'MantleScan', url: 'https://explorer.mantle.xyz/' },
//   },
//   contracts: {
//     multicall3: {
//       address: ADDRESSES.Multicall3 as any,
//       blockCreated: 3962,
//     },
//   },
// } satisfies Chain

// const mantleTestnet = {
//   id: 5000,
//   name: 'Mantle Chain',
//   network: 'mnt',
//   nativeCurrency: { decimals: 18, name: 'MNT', symbol: 'MNT' },
//   rpcUrls: {
//     default: { http: ['https://rpc.mantle.xyz'] },
//     public: { http: ['https://rpc.mantle.xyz'] },
//   },
//   blockExplorers: {
//     // etherscan: { name: 'MantleScan', url: 'https://explorer.mantle.xyz/' },
//     default: { name: 'MantleScan', url: 'https://explorer.mantle.xyz/' },
//   },
//   contracts: {
//     multicall3: {
//       address: ADDRESSES.Multicall3 as any,
//       blockCreated: 3962,
//     },
//   },
// } satisfies Chain

export const CHAINS = IS_PROD ? [mantle] : [mantleTestnet, mantle]

/**
 * Controls some L2 specific behavior, e.g. slippage tolerance, special UI behavior.
 * The expectation is that all of these networks have immediate transaction confirmation.
 */
export const L2_CHAIN_IDS: ChainId[] = []
